import {getBearerCredentials, getSimpleCredentials, isOpenidLogin} from '../proto/core/loginProps';
import {selectCompanyStore} from '../../features/SelectCompanyDlg/SelectCompanyStore';

export const getAuthorizationHeader = () => {
    if (isOpenidLogin()) {
        const data = getBearerCredentials();
        return 'Bearer ' + (data.Openid?.Token || '');
    }

    const data = getSimpleCredentials();

    if (!data.Simple?.Userlogin || !data.Simple?.Password) {
        throw new Error('Missing credentials');
    }
    return 'Basic ' + btoa(encodeURIComponent(`${data.Simple.Userlogin}:${data.Simple.Password}`));
};

export const getPostRequestOptions = data => ({
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        Prettyname: selectCompanyStore?.getPrettyName(),
        Authorization: getAuthorizationHeader()
    },
    body: JSON.stringify(data)
});

export const getBaseURL = () => {
    const {host = '', protocol} = window.location;
    const availableHosts = ['priority-connect.online'];

    if (availableHosts.some(availableHost => host.includes(availableHost))) {
        return `${protocol}//${host}`;
    }

    return 'https://d.priority-connect.online';
};
